<script>
import { Doughnut, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: {
    chartdata: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    doughnutData: {
      labels: [],
      datasets: [
        {
          backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
          data: []
        }
      ]
    },
    options: {
      plugin_one_attribute: 'HoiDapByLinhVuc',
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        position: 'right'
      },
      legendCallback: function(chart) {
        var text = [];
        text.push('<ul>');
        for (var i=0; i<chart.data.datasets.length; i++) {
          text.push('<li>');
          text.push(`<span style="background-color: ${chart.data.datasets[i].borderColor}>${chart.data.datasets[i].label}</span>`);
          text.push('</li>');
        }
        text.push('</ul>');
        return text.join("");
      },
      cutoutPercentage: 80,
      tooltips: {
        filter: function(item, data) {
          var label = data.labels[item.index];
          if (label) return item;
        }
      }
    }
  }),
  mounted() {
    this.getData();
  },
  methods: {
    getData(){
      const app = this;
      axios.get("api/v1/get-count-support-by-branch")
        .then(response => {
          let total = 0;
          app.doughnutData.labels = [];
          app.doughnutData.datasets[0].data = [];
          response.data.forEach(function(el){
            app.doughnutData.labels.push(el.name);
            app.doughnutData.datasets[0].data.push(el.amount);
            total+= parseInt(el.amount);
          })
          app.renderChart(app.doughnutData, app.options);
          app.textCenter(total);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    textCenter(val) {
      Chart.pluginService.register({
        beforeDraw: function(chart) {
          if (chart.config.options.plugin_one_attribute) {
            var width = chart.chart.width - chart.legend.width,
              height = chart.chart.height,
              ctx = chart.chart.ctx;

            ctx.restore();
            var fontSize = (height / 114).toFixed(2);
            ctx.font = fontSize + "em sans-serif";
            ctx.textBaseline = "middle";

            var text = `Σ: ${val}`,
              textX = Math.round((width - ctx.measureText(text).width) / 2),
              textY = height / 2;

            ctx.fillText(text, textX, textY);
            ctx.save();
          }
        }
      });
    }
  }
}
</script>